// ShiftQuote tactical wordmark
export function BrandWord({ className = "" }) {
  return (
    <span className={`inline-flex items-baseline font-heading ${className}`}>
      <span className="text-[#2563EB] text-[1.35em] font-black leading-[0.85] tracking-tight -mr-[0.02em]">
        S
      </span>
      <span className="font-bold tracking-tight">hift</span>
      <span className="text-[#2563EB] text-[1.35em] font-black leading-[0.85] tracking-tight -ml-[0.01em] -mr-[0.02em]">
        Q
      </span>
      <span className="font-bold tracking-tight">uote</span>
    </span>
  );
}
